module.exports = __webpack_public_path__ + "img/電気回路_3_2.9df5ce06.png";